<template>
  <div class="wrapper wrapper_wide section_content" :class="{offline: !isOnline}">
    <div class="frame_center">
      <!-- <div class="blk_feature">
        <div class="feature_photo"><img src="/assets/img/contact/img_contact.png" alt=""></div>
      </div> -->
      <!-- <Consultation :mail="false"/> -->
      <Form />
    </div>
  </div>
</template>

<script>
// organisms
import Consultation from '../organisms/consultation.vue'
import Form from '../organisms/form.vue'

export default {
  name: 'ContactContents',
  components: {
    Consultation,
    Form
  },
  props: {
    msg: String
  },
  computed: {
    isOnline () {
      return navigator.onLine
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
